import React from 'react';
import { createTheme } from '@mui/material/styles';
import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";
import { SVG_GRADIENT_BLUE } from '../Button/ButtonStyles';

const theme = createTheme();

export const useStyles = () => ({
    // For System View
    systemBoxContainer: css({
        position: 'relative',
        boxSizing: 'border-box',
        padding: '20px 24px',
        width: '100%',
        background: 'transparent',
        backgroundSize: '0% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'border-box',
        border: `4px solid ${Color.primary[600]}`,
        borderImage: `url('data:image/svg+xml;base64,${SVG_GRADIENT_BLUE}') 10% stretch`,
        transition: 'all .2s ease-in-out',
    }),
    systemBoxHeader: css({
        display: 'inline-flex',
        alignItems: 'center',
    }),
    systemBoxShowMore: css({
        '& svg': {
            position: 'absolute',
            top: 16,
            right: 16,
            width: 20,
            height: 20,
            color: Color.primary[400],
        },
    }),
    systemBoxDatabase: css({
        display: 'inline-flex',
        alignItems: 'center',
        marginTop: 17,
        '& svg': {
            color: Color.primary[400],
        },
    }),
    systemDeviceCountContainer: css({
        display: 'block',
        width: '100%',
    }),
    systemDeviceCount: css({
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%',
    }),
    systemApplicationFunctionIconListContainer: css({
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%',
        marginTop: 5,
    }),
    systemApplicationFunctionIconStatus: css({
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: Color.alert[700],
        position: 'absolute',
        top: 0,
        left: 0,
    }),
    systemApplicationFunction: css({
        position: 'relative',
        '& svg': {
            fontSize: 40,
        },
    }),
    activeFunction: css({
        '& svg': {
            color: Color.primary[400],
        },
    }),
    inactiveFunction: css({
        '& svg': {
            color: Color.neutral[500],
        },
    }),
    moreActionIconContainer: css({
        position: 'absolute',
        top: 30,
        right: 40,
        cursor: 'pointer',
    }),
    // End System View
    // For List Header
    root: css({
        width: '100%',
    }),
    paper: css({
        width: '100%',
        marginBottom: theme.spacing(2),
    }),
    table: css({
        minWidth: 750,
    }),
    visuallyHidden: css({
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    }),
    // End List Header
});
